// import demo from './app/demo';
import uFaculty from './app/u-faculty'
import adminPanel from './app/admin-panel-front-dev'
import strategicTracking from './app/u-faculty/strategicTracking'
import integralEvaluation from './app/u-faculty/integralEvaluation'
import workplan from './app/u-faculty/workplan'
import integration from './app/integration-front'
//import reportes from './app/u-faculty/reportes'

export default angular.module('app.uplanner', [
 // demo,
  workplan,
  uFaculty,
  strategicTracking,
  integralEvaluation,
  adminPanel,
  integration
  ])
  .name


// WEBPACK FOOTER //
// ./src/projects.js